import styled from 'styled-components';
import color from '../utils/style/color';
import space from '../utils/style/space';

const FormLabel = styled.p`
  line-height: 1.8;
  font-size: 15px;
  color: ${color.gray.xxDark};
  margin-bottom: ${space.xxxs}px;
`;

export default FormLabel;
